// extracted by mini-css-extract-plugin
module.exports = {"parallax":"styles_parallax__uplz4","parallaxTitle":"styles_parallaxTitle__zmD7p","parallaxCredits":"styles_parallaxCredits__ofi5w"};